import dynamic from 'next/dynamic';
import React from 'react';
import { Query } from 'react-apollo';
import { translate } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import getThePlaceSlidesByType from '../../src/apollo/graphql/place/getThePlaceSlidesByType';
import { Container } from '../../src/components/Grid';
import { Media, Section } from '../../src/components/Layout';
import { media } from '../../src/styles/media';
import sortByOrder from '../../src/utils/collection/sortByOrder';
import createContext from '../../src/utils/format/createContext';

const SliderComponentWithNoSSR = dynamic(
  import('../../src/components/Slider'),
  {
    loading: () => <p>Loading...</p>,
    ssr: false
  }
);

const Wrapper = styled.div`
  position: relative;

  .slick-slide {
    padding: 0;
    flex: inherit;
  }

  .slick-disabled {
    display: none;
  }

  .slick-track {
    overflow-x: hidden;
  }

  .slick-dots {
    li {
      height: 2px;
      width: 12px;
      margin-right: 7px;
      border-radius: 0px;
      background-color: ${({ theme }) => theme.color.brand.lightGrey2};
      transition: all 0.3s ease;
    }

    .slick-active {
      width: 42px;
      background-color: ${({ theme }) => theme.color.brand.accent};
    }
  }

  .slick-arrow {
    top: 40vw;
    z-index: 9;
    transform: none;
  }

  .slick-next {
    right: 0;
  }

  .slick-prev {
    left: 0;
  }

  ${media.tablet`
    .slick-slide {
      padding: 10px;
    }
    .slick-arrow {
      top: 50%;
      transform: translate(0,-50%);
    }
    .slick-next {
      right: -25px;
    }

    .slick-prev {
      left: -25px;
    }
  `};
`;

const CustomMedia = styled(Media)`
  h2,
  p {
    text-align: left;
  }

  padding: 5px;
`;

class Intro extends React.PureComponent {
  render() {
    const { i18n } = this.props;
    return (
      <Section>
        <Container>
          <Wrapper>
            <Fade up>
              <Query
                query={getThePlaceSlidesByType}
                variables={{ type: 'content' }}
                context={createContext(i18n.language)}
              >
                {({ loading, error, data }) => {
                  if (
                    !loading &&
                    !error &&
                    data &&
                    data.getThePlaceSlidesByType
                  ) {
                    const carousel = data.getThePlaceSlidesByType;
                    if (carousel && carousel.length) {
                      const orderedCarousel = sortByOrder(carousel);
                      return (
                        <SliderComponentWithNoSSR
                          autoplay={false}
                          autoplaySpeed={5000}
                          slidesToShow={1}
                          slidesToScroll={1}
                          infinite={false}
                          dots={true}
                          unslick={orderedCarousel.length > 1 ? false : true}
                        >
                          {orderedCarousel.map((slide, index) => {
                            return (
                              <CustomMedia
                                key={index}
                                title={slide.detail.title}
                                img={slide.img_media_mobile}
                                imgDesktop={slide.img_media_desktop}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: slide.detail.content
                                  }}
                                />
                              </CustomMedia>
                            );
                          })}
                        </SliderComponentWithNoSSR>
                      );
                    }
                  }
                  return null;
                }}
              </Query>
            </Fade>
          </Wrapper>
        </Container>
      </Section>
    );
  }
}

export default translate()(Intro);
